import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
const Popup = forwardRef(({ title, className, children, open, zIndex }: any, ref) => {
  const [popupActive, setPopupActive] = useState<boolean>(open);
  const popupRef = useRef<any>();
  useImperativeHandle(ref, () => ({
    isOpen(val: boolean) {
      setPopupActive(val);
    }
  }))

  useEffect(() => {
    if (popupActive) {
      popupRef['current'].focus();
    }
  }, [popupActive])

  return (
    <>
      <div className={"modal fade" + (popupActive ? ' show' : '')} style={{ zIndex: zIndex ? zIndex : 1050 }}  >
        <div className={("modal-dialog modal-dialog-centered") + (className ? " " + className : '')}>
          <div className="modal-content" tabIndex={0} ref={popupRef} onKeyUp={(e) => { if (e.key === 'Escape') { setPopupActive(false) } }} >
            <div className="modal-header">
              <strong className="modal-title">{title}</strong>
              <button type="button" className="btn close" data-dismiss="modal" aria-label="Close" onClick={() => { setPopupActive(false) }} />
            </div>
            {children}
          </div>
        </div>
      </div>
      <div className={"modal-backdrop fade" + (popupActive ? ' show' : '')} style={{ zIndex: zIndex ? zIndex - 1 : 1049 }}></div>
    </>
  );
})

export default Popup;
